module.exports = __webpack_public_path__ + "static/media/California_Judicial_Council_seal.dfdee5ed.png";